export const getDifferenceInSelection = (
	currentValue: string[],
	value: string[]
): { diff: string | undefined; added: boolean } => {
	// This diff is kinda expensive at O(n^2) but the alternative is
	// using sets, where the diff is cheap but extracting the value
	// is always done with iterables. We're also assuming that
	// the diff has length 1.
	const added = currentValue.length < value.length;
	const diff = added
		? value.find((x) => !currentValue.includes(x))
		: currentValue.find((x) => !value.includes(x));
	return { diff, added };
};
